import { render, staticRenderFns } from "./SellComponent.vue?vue&type=template&id=4c481a91&scoped=true&"
import script from "./SellComponent.vue?vue&type=script&lang=js&"
export * from "./SellComponent.vue?vue&type=script&lang=js&"
import style0 from "./SellComponent.vue?vue&type=style&index=0&id=4c481a91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c481a91",
  null
  
)

export default component.exports